var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepagewide-layout"},[_c('HomepageLayout',{attrs:{"wide-header":_vm.wideHeader,"heroDark":_vm.heroDark}},[_vm._t("default")],2),_vm._v(" "),(_vm.footer !== 'no')?_c('BottomNavigation'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad23e3a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/HomepageWideLayout.vue
// module id = wpHw
// module chunks = 1